module.exports = __webpack_public_path__ + "img/cfae864.svg";